<template lang="pug">
  v-card.agent-status-card(elevation="2")
    v-card-text.height-100-percent
      .d-flex.flex-column.justify-space-around.height-100-percent
        .d-flex.justify-space-between.align-center
          .agent-name-container
            p.agent-name.text-truncate.ma-0(:style="{ fontSize: `${16 / (4 * 2)}vh`, lineHeight: `${18 / (4 * 2)}vh` }") {{ agentName }}
          .call-stats.text-caption
            v-icon(small color="success" :style="{ fontSize: `${14 / (4 * 2)}vh` }") mdi-phone-outgoing
            span.mx-1.mt-2(:style="{ fontSize: `${14 / (4 * 2)}vh` }") {{ outboundCallsToday }}
            v-icon(small color="primary" :style="{ fontSize: `${14 / (4 * 2)}vh` }") mdi-phone-incoming
            span.ml-1.mt-2(:style="{ fontSize: `${14 / (4 * 2)}vh` }") {{ inboundCallsToday }}
        
        .d-flex.justify-space-between.align-center
          .status-name-container
            p.status-name.grey--text.text-truncate.ma-0(:style="{ fontSize: `${14 / (4 * 2)}vh`, lineHeight: `${16 / (4 * 2)}vh` }") {{ agentStatusName }}

          v-chip(
            :class="{ 'flash-animation': timeInSeconds > agentStatusCriticalRule.metric && isOnline }"
            :color="timerColor"
            dark
            :style="{ fontSize: `${14 / (4 * 2)}vh`, height: `${18 / (4 * 2)}vh` }"
          )
            template(v-if="isOnline")
              v-icon(left :style="{ fontSize: `${14 / (4 * 2)}vh` }") {{ getAgentStatusIcon }}
              span.timer(:style="{ fontSize: `${14 / (4 * 2)}vh` }") {{ timeInSeconds | secondsToFullWords }}
            template(v-else)
              v-icon(left :style="{ fontSize: `${14 / (4 * 2)}vh` }") {{ getAgentStatusIcon }}
              span.timer(:style="{ fontSize: `${14 / (4 * 2)}vh` }") | Agent Offline
  </template>
    
    <script lang="ts">
    import Vue from 'vue';
    
    export default Vue.extend({
        data() {
            return {
                percentage: 70,
            }
        },
      props: {
        agentName: String,
        agentStatusType: Number,
        agentStatusName: String,
        longestWaiting: Number,
        status: String, 
        outboundCallsToday: Number,
        inboundCallsToday: Number,
        isOnline: Boolean,
        timeInSeconds: Number,
        tableRowCount: Number,
        agentStatusWarningRule: Object,
        agentStatusCriticalRule: Object,

      },
    
      computed: {
        timerColor(): string {
            if (!this.isOnline) {
                return 'grey';
            }

            if (this.timeInSeconds > this.agentStatusCriticalRule.metric) {
                return this.agentStatusCriticalRule.display_color;
            } else if (this.timeInSeconds > this.agentStatusWarningRule.metric) {
                return this.agentStatusWarningRule.display_color;
            } else {
                return 'var(--success)';
            }
        },
        getAgentStatusIcon(): string {
            if (!this.isOnline) {
                return 'mdi-account-off';
            }

            switch (this.agentStatusType) {
                case 0:
                    return 'mdi-phone-incoming';
                case 1:
                    return 'mdi-phone-outgoing';
                case 2:
                    return 'mdi-phone-incoming-outgoing';
                case 3:
                    return 'mdi-phone-hangup';
                case 6:
                    return 'mdi-cellphone-text';
                case 7:
                    return 'mdi-email';
                default:
                    return 'mdi-phone-hangup';
            }
              // enums for status types
              // inbound: 0,
              // outbound: 1,
              // both: 2,
              // neither: 3,
              // non_production: 4,
              // session: 5,
              // sms_message: 6,
              // email: 7
        },
        percentageIcon(): string {
          return this.percentage >= 90 ? 'mdi-arrow-up' : 'mdi-arrow-down';
        },
    
        percentageColor(): string {
          return this.percentage >= 90 ? 'success' : 'error';
        },
    
        percentageTextColor(): string {
          return this.percentage >= 90 ? 'success--text' : 'error--text';
        },
      },
      mounted() {
      },
      
    });
    </script>
    
    <style lang="scss" scoped>
      .agent-status-card {
        min-width: 16%;
        max-width: 16%;
        flex-shrink: 0;  /* Prevent cards from shrinking */
      }

      .agent-name-container {
        max-width: 60%;
      }

      .call-stats {
        white-space: nowrap;
        max-width: 40%;
      }

      .timer {
        font-size: 0.75rem;
      }

    @keyframes flash {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.5; }
    }

    .flash-animation {
      animation: flash 1s infinite;
    }

    .status-name-container {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      overflow: hidden;
      flex: 1;
      padding-right: 8px;
    }

</style>